import { constants } from "../constants/redux-constants";

const initialState = {
  package: {},
  plan_status: "",
};

const licenseReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants?.LICENSE?.PACKAGE:
      return {
        ...state,
        package: action?.payload,
      };

    case constants?.LICENSE?.PLAN_STATUS:
      return {
        ...state,
        plan_status: action?.payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default licenseReducer;
